const benefit = () => {
  const items = document.querySelectorAll('.js-benefit-item');
  if (items.length > 0) {
    items.forEach(elementItem => {
      const btn = elementItem.querySelector('.js-benefit-toggle');
      if (!btn) return;
      btn.addEventListener('click', () => {
        elementItem.classList.toggle('active');
      });
    });
  }
};

export default benefit;
